import debug from 'debug';
export var getNamespacedLogger = function (namespace) {
    var log = debug(namespace);
    // eslint-disable-next-line no-console
    log.log = console.log.bind(console);
    return log;
};
export var getExtendedLogger = function (extension, logger) {
    return logger.extend(extension);
};
//# sourceMappingURL=helpers.js.map